"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// THE WHOLE SCENARIO FOR THE FACILITATOR, during the run: the summary in the "Patient now" strip
// (data/screens/patientstatus.js) and the "Full scenario" window it opens. Everything the briefing
// page shows (data/screens/setup.js BriefingScreen), plus the obs it starts with and what Better and
// Worse do, so nothing has to be remembered from the briefing.
(function () {
  var list = function list(v) {
    return Array.isArray(v) ? v.filter(Boolean) : v ? [v] : [];
  };
  var OBS = [['hr', 'HR'], ['bpSys', 'BP'], ['spO2', 'SpO2'], ['rr', 'RR'], ['temp', 'Temp'], ['gcs', 'GCS'], ['bm', 'Glucose'], ['etco2', 'ETCO2']];
  var obsText = function obsText(v) {
    if (!v) return null;
    var parts = OBS.filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        k = _ref2[0];
      return v[k] !== undefined && v[k] !== null && v[k] !== '';
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        k = _ref4[0],
        l = _ref4[1];
      return k === 'bpSys' ? "BP ".concat(v.bpSys).concat(v.bpDia !== undefined ? '/' + v.bpDia : '') : "".concat(l, " ").concat(v[k]).concat(k === 'spO2' ? '%' : '');
    });
    return parts.length ? parts.join(' · ') : null;
  };
  var profileOf = function profileOf(s) {
    return s.profile || (window.formatProfileTemplate ? window.formatProfileTemplate(s.patientProfileTemplate || '', s.patientAge, s.sex) : '');
  };
  // "Sam Jones (45y M)", leaving out whatever the scenario does not give
  var whoText = function whoText(s) {
    var age = s.patientAge !== undefined && s.patientAge !== null && s.patientAge !== '' ? window.shortAge ? window.shortAge(s.patientAge) : s.patientAge : '';
    var bits = [age, s.sex].filter(Boolean).join(' ');
    return [s.patientName, bits && "(".concat(bits, ")")].filter(Boolean).join(' ');
  };
  var actionLabel = function actionLabel(k) {
    return window.INTERVENTIONS && window.INTERVENTIONS[k] && window.INTERVENTIONS[k].label || k;
  };

  // In the strip: who, what, the story and what happens next, with the button for the rest.
  var ScenarioSummary = function ScenarioSummary(_ref5) {
    var scenario = _ref5.scenario,
      onOpen = _ref5.onOpen;
    var _window = window,
      HumanFactorBadge = _window.HumanFactorBadge;
    var s = scenario || {};
    var brief = s.instructorBrief || {};
    return /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1 basis-full md:basis-0 flex flex-col gap-1 md:max-w-[34rem]",
      "data-testid": "scenario-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-baseline gap-2 flex-wrap"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[9px] uppercase font-bold text-slate-400"
    }, "Scenario"), /*#__PURE__*/React.createElement("span", {
      className: "text-xs font-bold text-emerald-300 uppercase"
    }, s.title), /*#__PURE__*/React.createElement(HumanFactorBadge, {
      hf: s.hf
    })), whoText(s) && /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-white font-bold"
    }, whoText(s)), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-200 line-clamp-3"
    }, profileOf(s)), brief.progression && /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-amber-200/90 line-clamp-2"
    }, /*#__PURE__*/React.createElement("b", {
      className: "text-amber-300"
    }, "Progression: "), brief.progression), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onOpen,
      "data-testid": "open-full-scenario",
      className: "self-start mt-0.5 text-[10px] uppercase font-bold px-2 py-1 rounded border border-sky-500 text-sky-200 bg-sky-900/40 hover:bg-sky-800/60"
    }, "Full scenario"));
  };
  var Block = function Block(_ref6) {
    var title = _ref6.title,
      tone = _ref6.tone,
      children = _ref6.children;
    return /*#__PURE__*/React.createElement("div", {
      className: "p-3 rounded border ".concat(tone || 'border-slate-700 bg-slate-900/50')
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold uppercase tracking-wider mb-1 text-slate-300"
    }, title), children);
  };
  var Bullets = function Bullets(_ref7) {
    var items = _ref7.items;
    return /*#__PURE__*/React.createElement("ul", {
      className: "list-disc pl-4 text-sm text-slate-200 space-y-0.5"
    }, items.map(function (l, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, String(l));
    }));
  };
  var FullScenarioModal = function FullScenarioModal(_ref8) {
    var scenario = _ref8.scenario,
      onClose = _ref8.onClose;
    var _window2 = window,
      Modal = _window2.Modal,
      Button = _window2.Button,
      Lucide = _window2.Lucide,
      HumanFactorBadge = _window2.HumanFactorBadge;
    var s = scenario || {};
    var brief = s.instructorBrief || {};
    var objectives = list(brief.debriefPoints || brief.learningObjectives || s.learningObjectives);
    var evo = s.evolution || {};
    var better = evo.improved ? obsText(evo.improved.vitals) : null;
    var worse = evo.deteriorated ? obsText(evo.deteriorated.vitals) : null;
    var injuries = window.Injuries ? window.Injuries.forScenario(s).map(window.Injuries.label) : [];
    return /*#__PURE__*/React.createElement(Modal, {
      fixed: true,
      label: "Full scenario: ".concat(s.title || ''),
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-5 rounded-lg border border-slate-600 w-full max-w-3xl shadow-2xl max-h-[90vh] flex flex-col",
      "data-testid": "full-scenario"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-start gap-3 mb-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-xl font-bold text-white"
    }, s.title), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2 mt-1 text-xs"
    }, [s.category, s.ageRange, s.acuity].filter(Boolean).map(function (t) {
      return /*#__PURE__*/React.createElement("span", {
        key: t,
        className: "bg-slate-700 text-slate-200 px-2 py-0.5 rounded border border-slate-600"
      }, t);
    }), /*#__PURE__*/React.createElement(HumanFactorBadge, {
      hf: s.hf
    }))), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close the full scenario",
      onClick: onClose,
      className: "text-slate-400 hover:text-white flex-none"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "overflow-y-auto pr-1 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, /*#__PURE__*/React.createElement(Block, {
      title: "Patient"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-white font-bold"
    }, whoText(s), s.wetflag && s.wetflag.weight ? ", ".concat(s.wetflag.weight, " kg") : ''), s.presentingComplaint && /*#__PURE__*/React.createElement("p", {
      className: "text-slate-300"
    }, "Presenting: ", s.presentingComplaint), /*#__PURE__*/React.createElement("p", {
      className: "text-slate-200 mt-1 leading-relaxed"
    }, profileOf(s)), /*#__PURE__*/React.createElement("div", {
      className: "mt-2 space-y-0.5 text-slate-300"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-400"
    }, "PMH:"), " ", list(s.pmh).join(', ') || 'Nil'), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-400"
    }, "Medicines:"), " ", list(s.dhx).join(', ') || 'Nil'), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-400"
    }, "Allergies:"), " ", /*#__PURE__*/React.createElement("span", {
      className: "text-red-300 font-bold"
    }, list(s.allergies).join(', ') || 'NKDA')))), injuries.length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Injuries (as on the patient picture)"
    }, /*#__PURE__*/React.createElement(Bullets, {
      items: injuries
    })), obsText(s.vitals) && /*#__PURE__*/React.createElement(Block, {
      title: "Obs at the start"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-slate-200"
    }, obsText(s.vitals))), (better || worse) && /*#__PURE__*/React.createElement(Block, {
      title: "Better / Worse go to"
    }, better && /*#__PURE__*/React.createElement("p", {
      className: "text-emerald-300"
    }, /*#__PURE__*/React.createElement("b", null, "Better:"), " ", better), worse && /*#__PURE__*/React.createElement("p", {
      className: "text-red-300"
    }, /*#__PURE__*/React.createElement("b", null, "Worse:"), " ", worse)), s.hf && s.hf.id !== 'hf0' && s.hf.description && /*#__PURE__*/React.createElement(Block, {
      title: "Human factors",
      tone: "border-fuchsia-600/40 bg-fuchsia-900/20"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-slate-200"
    }, s.hf.description))), /*#__PURE__*/React.createElement("div", {
      className: "space-y-3"
    }, brief.progression && /*#__PURE__*/React.createElement(Block, {
      title: "Clinical progression",
      tone: "border-amber-600/40 bg-amber-900/20"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-slate-200 leading-relaxed"
    }, brief.progression)), list(brief.interventions).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Key interventions",
      tone: "border-emerald-600/40 bg-emerald-900/20"
    }, /*#__PURE__*/React.createElement(Bullets, {
      items: list(brief.interventions)
    })), list(s.recommendedActions).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Recommended actions"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-slate-200"
    }, list(s.recommendedActions).map(actionLabel).join(', '))), objectives.length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Learning objectives",
      tone: "border-indigo-600/40 bg-indigo-900/20"
    }, /*#__PURE__*/React.createElement(Bullets, {
      items: objectives
    })), list(s.equipment).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Equipment"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-slate-200"
    }, list(s.equipment).join(', '))), list(s.learningLinks).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Guidelines and resources"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-1"
    }, list(s.learningLinks).map(function (l, i) {
      return /*#__PURE__*/React.createElement("a", {
        key: i,
        href: l.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-xs text-sky-400 hover:underline"
      }, l.label);
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "border-t border-slate-700 pt-3 mt-3 flex justify-end"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: "secondary",
      className: "h-9 px-4"
    }, "Close"))));
  };
  window.ScenarioView = {
    ScenarioSummary: ScenarioSummary,
    FullScenarioModal: FullScenarioModal
  };
})();